<template>
  <div class="companies-card">
    <div class="company-details">
      <div class="company-image">
        <img v-bind:src="company.logo_src" style="width: 100%;"/>
      </div>

      <div class="company-rating">
        <div class="company-name">
          {{ company.name }}
        </div>
        <div>
          <div style="display: inline-block;" v-if="parseInt(rating) > 70">
            <div class="rating-dot green-rating"
                 v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating"
                 v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="parseInt(rating) > 30">
            <div class="rating-dot yellow-rating"
                 v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating"
                 v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="parseInt(rating) <= 30">
            <div class="rating-dot red-rating"
                 v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating"
                 v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="!parseInt(rating)">
            <div class="rating-dot null-rating" v-for="i in 10"></div>
          </div>
          <div class="company-remote-percentage">{{ rating }} Remote friendly</div>
        </div>
      </div>
    </div>

    <div class="company-description">
      <div class="row">
        <div class="col-6">
          <div class="desc-heading">Location</div>
          <div class="desc-sub">{{ company.city }}, {{ company.country }}</div>
        </div>
        <div class="col-6">
          <div class="desc-heading">WFH Status</div>
          <div class="desc-sub" v-text="getWorkFromHome()"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="desc-heading">Travel</div>
          <div class="desc-sub" v-text="getTravel()"></div>
        </div>
        <div class="col-6">
          <div class="desc-heading">Visitors</div>
          <div class="desc-sub" v-text="getVisitors()"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="desc-heading">Events</div>
          <div class="desc-sub" v-text="getEvents()"></div>
        </div>
        <div class="col-6 actions">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import remoteReadinessRating from './RemoteReadinessRating';
import DropDownOptions from './DropdownOptionsConfig';

export default {
  props: {
    company: {
      required: true,
    },
    remoteMeasures: {
      required: true,
    },
  },

  computed: {
    rating () {
      return remoteReadinessRating(this.remoteMeasures) + '%';
    },
  },

  methods: {
    getWorkFromHome () {
      return DropDownOptions['wfhOptions'][this.company.allow_work_from_home];
    },

    getTravel () {
      return DropDownOptions['travelOptions'][this.company.allow_travel];
    },

    getVisitors () {
      return DropDownOptions['visitorOptions'][this.company.allow_visitors];
    },

    getEvents () {
      return DropDownOptions['eventsOptions'][this.company.allow_events];
    },
  },
};
</script>

<style scoped>

</style>
